import App from "App";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "context/auth-context/auth.context";
import { SecurityProvider } from "context/security-context/security.context";
import { MaterialUIControllerProvider } from "context/materialUI-context/materialUI.context";
import "i18n";

const root = createRoot(document.getElementById("root"));
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1 * 60 * 60 * 1000,
      gcTime: 5 * 60 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <AuthProvider>
          <SecurityProvider>
            <App />
          </SecurityProvider>
        </AuthProvider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
